// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionsPopup_root__3A1Lz","info":"ActionsPopup_info__3INub"};